import {RootState} from '../rootReducer';

export const authSelector = (state: RootState) => state.auth;
export const authLoggedInUserSelector = (state: RootState) => state.auth.loggedInUser;
